/*
  UI Refresh helper (non-breaking):
  - Adds tasteful reveal-on-scroll animation
  - Respects prefers-reduced-motion
*/

(function () {
  "use strict";

  // Public helper: used by product cards (onclick) to add selected qty.
  // Keeps existing Shopify.addItem flow intact.
  window.UIRefreshAddToCart = function (variantId, productId) {
    try {
      var qty = 1;
      if (productId) {
        var root = document.querySelector('.single-product-wrap[data-product-id="' + productId + '"]');
        if (root) {
          var input = root.querySelector('.product-quantity input[name="quantity"]');
          if (input && input.value) {
            var parsed = parseInt(input.value, 10);
            if (!isNaN(parsed) && parsed > 0) qty = parsed;
          }
        }
      }

      if (typeof Shopify !== 'undefined' && Shopify && typeof Shopify.addItem === 'function') {
        Shopify.addItem(variantId, qty);
      } else {
        // Fallback: nothing to do.
        // Intentionally silent to avoid breaking UX.
      }
    } catch (e) {
      // Intentionally swallow errors to avoid breaking storefront.
    }

    return false;
  };

  // Quantity +/- controls (for product cards and other cart-plus-minus instances)
  // Uses event delegation to work with dynamically injected markup.
  (function initQtyButtons() {
    // Theme already binds qty buttons via jQuery in snippets/footer-js.liquid.
    // Running a second handler causes double increments (e.g. 1 -> 3).
    if (window.jQuery) return;

    function normalizeQtyButtons(root) {
      try {
        var scope = root || document;
        var wraps = scope.querySelectorAll ? scope.querySelectorAll('.cart-plus-minus') : [];
        if (!wraps || !wraps.length) return;

        for (var i = 0; i < wraps.length; i++) {
          var wrap = wraps[i];
          if (!wrap) continue;

          var decs = wrap.querySelectorAll('.dec.qtybutton');
          var incs = wrap.querySelectorAll('.inc.qtybutton');

          // Keep the first one, remove the rest.
          for (var d = 1; d < decs.length; d++) {
            if (decs[d] && decs[d].parentNode) decs[d].parentNode.removeChild(decs[d]);
          }
          for (var n = 1; n < incs.length; n++) {
            if (incs[n] && incs[n].parentNode) incs[n].parentNode.removeChild(incs[n]);
          }
        }
      } catch (e) {
        // Silent by design.
      }
    }

    function clampQty(n) {
      if (!n || isNaN(n)) return 1;
      if (n < 1) return 1;
      return n;
    }

    function handle(target) {
      if (!target) return;
      if (!target.classList || !target.classList.contains('qtybutton')) return;

      var wrap = target.closest && target.closest('.cart-plus-minus');
      if (!wrap) return;

      var input = wrap.querySelector('input[name="quantity"]');
      if (!input) return;

      var current = parseInt((input.value || '1').toString().trim(), 10);
      current = clampQty(current);

      var next = current;
      if (target.classList.contains('inc')) next = current + 1;
      if (target.classList.contains('dec')) next = current - 1;
      next = clampQty(next);

      input.value = String(next);
      try {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {}
    }

    document.addEventListener(
      'click',
      function (e) {
        // If another script injected duplicate buttons, clean them up on interaction.
        normalizeQtyButtons(document);
        handle(e.target);
      },
      { passive: true }
    );

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var t = e.target;
      if (!t || !t.classList || !t.classList.contains('qtybutton')) return;
      e.preventDefault();
      normalizeQtyButtons(document);
      handle(t);
    });

    // Initial cleanup (and handle cases where another script injects buttons later).
    normalizeQtyButtons(document);

    try {
      if ('MutationObserver' in window) {
        var t;
        var mo = new MutationObserver(function (mutations) {
          // Throttle to avoid excessive work.
          if (t) return;
          t = window.setTimeout(function () {
            t = null;
            // Try to normalize only in the areas that changed.
            for (var i = 0; i < mutations.length; i++) {
              var m = mutations[i];
              if (!m || !m.addedNodes || !m.addedNodes.length) continue;
              for (var j = 0; j < m.addedNodes.length; j++) {
                var node = m.addedNodes[j];
                if (node && node.querySelectorAll) {
                  normalizeQtyButtons(node);
                }
              }
            }
            // Fallback: in case nodes were moved around.
            normalizeQtyButtons(document);
          }, 120);
        });

        mo.observe(document.documentElement || document.body, {
          childList: true,
          subtree: true
        });
      }
    } catch (e) {
      // Silent by design.
    }
  })();

  function prefersReducedMotion() {
    try {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function addRevealToNodes(nodes) {
    if (!nodes || !nodes.length) return;

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el || el.classList.contains('ui-reveal')) continue;
      el.classList.add('ui-reveal');
    }
  }

  function initReveal() {
    if (prefersReducedMotion()) return;

    var selectors = [
      '.single-product-wrap',
      '.section-title',
      '.deal-section .deal-section-main',
      '.testimonial-area .testimonial-main',
      '.collection-img-wrap',
      '.shop-sidebar-wrap',
      '.cart-page .grid-wrapper',
      '.blog-content-wrap .blog-post',
      '.branches-section .branch-card',
      '.newsletter'
    ];

    var all = [];
    selectors.forEach(function (sel) {
      var nodes = document.querySelectorAll(sel);
      if (nodes && nodes.length) {
        addRevealToNodes(nodes);
        nodes.forEach(function (n) { all.push(n); });
      }
    });

    if (!all.length) return;

    if (!('IntersectionObserver' in window)) {
      all.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { root: null, threshold: 0.12, rootMargin: '0px 0px -10% 0px' });

    all.forEach(function (el) { io.observe(el); });
  }

  function initBranchesSliders() {
    try {
      if (typeof window.Swiper === 'undefined') return;

      var sliders = document.querySelectorAll('.ui-branches-swiper[data-branches-swiper]');
      if (!sliders || !sliders.length) return;

      for (var i = 0; i < sliders.length; i++) {
        var el = sliders[i];
        if (!el || el.getAttribute('data-ui-inited') === '1') continue;

        var slides = el.querySelectorAll('.swiper-slide');
        var hasLoop = slides && slides.length > 1;

        var pagination = el.querySelector('.swiper-pagination');
        var prev = el.querySelector('.swiper-button-prev');
        var next = el.querySelector('.swiper-button-next');

        // eslint-disable-next-line no-new
        new window.Swiper(el, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: hasLoop,
          speed: 520,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          preloadImages: false,
          watchSlidesProgress: true,
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1
          },
          autoplay: hasLoop
            ? {
                delay: 3600,
                disableOnInteraction: false
              }
            : false,
          pagination: pagination
            ? {
                el: pagination,
                clickable: true
              }
            : undefined,
          navigation:
            prev && next
              ? {
                  prevEl: prev,
                  nextEl: next
                }
              : undefined
        });

        el.setAttribute('data-ui-inited', '1');
      }
    } catch (e) {
      // Silent by design.
    }
  }

  function initMegaHoverIntent() {
    try {
      // Desktop-only: theme uses a hover dropdown; we add a small delay to prevent accidental close.
      if (!window.matchMedia || !window.matchMedia('(min-width: 1200px)').matches) return;

      var root = document.querySelector('.header-kaj .megamenu-content');
      if (!root) return;

      var OPEN_DELAY = 90;
      var CLOSE_DELAY = 180;

      function getItemFromTarget(t) {
        if (!t) return null;
        return t.closest ? t.closest('li.menu-link.parant') : null;
      }

      function setOpen(li, open) {
        if (!li || !li.classList) return;
        if (open) li.classList.add('ui-hover-open');
        else li.classList.remove('ui-hover-open');
      }

      function clearTimers(li) {
        if (!li) return;
        if (li.__uiOpenT) {
          window.clearTimeout(li.__uiOpenT);
          li.__uiOpenT = null;
        }
        if (li.__uiCloseT) {
          window.clearTimeout(li.__uiCloseT);
          li.__uiCloseT = null;
        }
      }

      root.addEventListener('mouseenter', function (e) {
        var li = getItemFromTarget(e.target);
        if (!li) return;
        clearTimers(li);
        li.__uiOpenT = window.setTimeout(function () {
          setOpen(li, true);
          li.__uiOpenT = null;
        }, OPEN_DELAY);
      }, true);

      root.addEventListener('mouseleave', function (e) {
        var li = getItemFromTarget(e.target);
        if (!li) return;
        clearTimers(li);
        li.__uiCloseT = window.setTimeout(function () {
          setOpen(li, false);
          li.__uiCloseT = null;
        }, CLOSE_DELAY);
      }, true);

      // Keyboard: keep open while focused, close a moment after focus leaves.
      root.addEventListener('focusin', function (e) {
        var li = getItemFromTarget(e.target);
        if (!li) return;
        clearTimers(li);
        setOpen(li, true);
      });

      root.addEventListener('focusout', function (e) {
        var li = getItemFromTarget(e.target);
        if (!li) return;
        clearTimers(li);
        li.__uiCloseT = window.setTimeout(function () {
          // Only close if focus didn't move within the same menu item.
          if (!li.contains(document.activeElement)) setOpen(li, false);
          li.__uiCloseT = null;
        }, CLOSE_DELAY);
      });
    } catch (e) {
      // Silent by design.
    }
  }

  function formatTLSpacingInText(text) {
    if (!text) return text;
    // Insert a non-breaking space between number and TL (e.g. 780.07TL -> 780.07\u00A0TL)
    // Idempotent: won't keep adding spaces.
    return text.replace(/(\d)\s*TL\b/g, '$1\u00A0TL');
  }

  function applyTLSpacing(root) {
    try {
      var scope = root || document;
      var selectors = [
        '#ProductPrice',
        '#ComparePrice',
        '.price-box .new-price',
        '.price-box .old-price',
        '.price-part .new-price',
        '.price-part .old-price'
      ];

      for (var i = 0; i < selectors.length; i++) {
        var nodes = scope.querySelectorAll(selectors[i]);
        if (!nodes || !nodes.length) continue;

        for (var j = 0; j < nodes.length; j++) {
          var el = nodes[j];
          if (!el) continue;
          var raw = (el.textContent || '').trim();
          if (!raw) continue;
          var next = formatTLSpacingInText(raw);
          if (next !== raw) {
            el.textContent = next;
          }
        }
      }
    } catch (e) {
      // Silent by design.
    }
  }

  function initTLSpacingObserver() {
    try {
      if (!('MutationObserver' in window)) return;
      // Prefer a narrow container to avoid observing the whole page.
      var target =
        document.querySelector('.product-details-page') ||
        document.querySelector('.collection-template') ||
        document.querySelector('main');
      if (!target) return;

      var t;
      function schedule() {
        if (t) return;
        t = window.setTimeout(function () {
          t = null;
          applyTLSpacing(document);
        }, 100);
      }

      var mo = new MutationObserver(function () {
        schedule();
      });

      mo.observe(target, {
        subtree: true,
        childList: true,
        characterData: true
      });
    } catch (e) {
      // Silent by design.
    }
  }

  function clampNonNegativeNumberText(el) {
    if (!el) return;
    var raw = (el.textContent || '').trim();
    if (!raw) return;
    var n = parseInt(raw, 10);
    if (isNaN(n)) return;
    if (n < 0) el.textContent = '0';
  }

  function initDealSectionCountdownClamp() {
    try {
      var ids = ['deal_banner_days', 'deal_banner_hours', 'deal_banner_minutes', 'deal_banner_seconds'];
      var els = [];
      for (var i = 0; i < ids.length; i++) {
        var el = document.getElementById(ids[i]);
        if (el) els.push(el);
      }
      if (!els.length) return;

      function clampAll() {
        for (var j = 0; j < els.length; j++) clampNonNegativeNumberText(els[j]);
      }

      clampAll();

      if (!('MutationObserver' in window)) {
        window.setInterval(clampAll, 1000);
        return;
      }

      var mo = new MutationObserver(function () {
        clampAll();
      });

      for (var k = 0; k < els.length; k++) {
        mo.observe(els[k], { subtree: true, childList: true, characterData: true });
      }
    } catch (e) {
      // Silent by design.
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    applyTLSpacing(document);
    initTLSpacingObserver();
    initBranchesSliders();
    initMegaHoverIntent();
    initDealSectionCountdownClamp();
  });
})();
